// The page the user lands on after opening the app and without a session
export const FirstRunPage = "TutorialPage";

// The main page the user will see as they use the app over a long period of time.
// Change this if not using tabs
export const MainPage = "TabsPage";

// The initial root pages for our tabs (remove if not using tabs)
export const Tab1Root = "ListMasterPage";
export const Tab2Root = "CalendarPage";
export const Tab3Root = "SettingsPage";
export const Tab4Root = "NotificationsPage";
export const Tab5Root = "TrainingsPage";
export const VouchersPage = "VouchersPage";

export const FutureTrainingsPage = "FutureTrainingsPage";



// WEBPACK FOOTER //
// ./src/app/pages/index.ts